export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.14-0828.04",
  commitId: "a4393c0f67a7097db96d85d56e673fb9d21e4137",
  commitTime: "2026-04-14T08:28:04.000Z",
});
